import { useEffect, useState } from 'react';
import styles from '../animation.module.css';
// Animation styles loaded only when component is used

const Error = ({ size }) => {
  const [toggleAnimation, setToggleAnimation] = useState<boolean>();

  useEffect(() => {
    setTimeout(() => {
      setToggleAnimation(!toggleAnimation);
    }, 2000);
  }, [toggleAnimation]);

  return (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      className={`${styles.error} ${toggleAnimation ? styles.toggle : ''}`}
    >
      <circle
        className="solid"
        fill="none"
        strokeLinecap="round"
        strokeWidth="4"
        strokeMiterlimit="10"
        cx="32"
        cy="32"
        r="30"
      />
      <circle
        className={`animation`}
        fill="none"
        strokeLinecap="round"
        strokeWidth="4"
        strokeMiterlimit="10"
        cx="32"
        cy="32"
        r="30"
      />

      <line
        className="left"
        fill="none"
        stroke="#000000"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="19.271"
        y1="19.521"
        x2="44.729"
        y2="44.979"
      />
      <line
        className="right"
        fill="none"
        stroke="#000000"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="44.729"
        y1="19.521"
        x2="19.271"
        y2="44.979"
      />
    </svg>
  );
};

export default Error;
